export interface IAppReportTaskTypeDocumentReference {
    documentId: string;
    documentName: string;
    documentPath: string;
}

export class AppReportTaskTypeDocumentReference implements IAppReportTaskTypeDocumentReference {
    documentId: string;
    documentName: string;
    documentPath: string;

    constructor();
    constructor(obj: IAppReportTaskTypeDocumentReference);
    constructor(obj?: any) {
        this.documentId = obj && obj.documentId || "";
        this.documentName = obj && obj.documentName || "";
        this.documentPath = obj && obj.documentPath || "";
    }
}